import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { stack } from '@/uiPrimitives/layout/stack';
import { hiddenAccessible } from '@/uiPrimitives/utility/display.css';
import { overflowClip } from '@/uiPrimitives/utility/overflow.css';
export const Progress = t0 => {
  const $ = _c(15);
  const {
    relevantQuestionsLength,
    remainingQuestionsLength
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(stack({
      rowGap: "2 | h2"
    }));
    t2 = classes(box({
      backgroundColor: "negative"
    }), overflowClip);
    t3 = classes(hiddenAccessible);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = relevantQuestionsLength - remainingQuestionsLength;
  let t5;
  if ($[3] !== remainingQuestionsLength) {
    t5 = remainingQuestionsLength > 1 ? translateInline({
      en: `At most ${remainingQuestionsLength} questions to go`,
      nl: `Nog maximaal ${remainingQuestionsLength} vragen te gaan`
    }) : translateInline({
      en: "This is the last question",
      nl: "Dit is de laatste vraag"
    });
    $[3] = remainingQuestionsLength;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== relevantQuestionsLength || $[6] !== t4 || $[7] !== t5) {
    t6 = <progress className={t3} max={relevantQuestionsLength} value={t4} aria-label={t5} />;
    $[5] = relevantQuestionsLength;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classes(box({
      backgroundColor: "positiveBlue",
      blockSize: "-2 | smaller"
    }));
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${(relevantQuestionsLength - remainingQuestionsLength) / relevantQuestionsLength * 100}%`;
  let t9;
  if ($[10] !== t8) {
    t9 = <i className={t7} style={{
      inlineSize: t8
    }} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t6 || $[13] !== t9) {
    t10 = <div className={t1}><div className={t2}>{t6}{t9}</div></div>;
    $[12] = t6;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};